import { EstimateComponent } from './estimate/estimate.component';
import { ProjectSetupsComponent } from './project-setups/project-setups.component';
import { SummaryComponent } from './summary/summary.component';
import { ActivitySelectionComponent } from './activity-selection/activity-selection.component';
import { ChargingProjectSetupComponent } from './charging-project-setup/charging-project-setup.component';
import { ProjectLayoutComponent } from './project-layout/project-layout.component';
import { FundingProjectComponent } from './funding-project/funding-project.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { Routes } from '@angular/router';
import { ItProjectSetupComponent } from './it-project-setup/it-project-setup.component';
import { ItProjectEstimateComponent } from './it-project-estimate/it-project-estimate.component';
import { ItProjectReviewComponent } from './it-project-review/it-project-review.component';
import { ItProjectApprovalComponent } from './it-project-approval/it-project-approval.component';
import { RealEstateProjectComponent } from './real-estate-project/real-estate-project.component';
import { AuthGuard } from './services/auth.guard';
const ɵ0 = () => import("./rre-projects/rre-projects.module.ngfactory").then((m) => m.RreProjectsModuleNgFactory), ɵ1 = () => import("./form-dashboard/form-dashboard.module.ngfactory").then((m) => m.FormDashboardModuleNgFactory), ɵ2 = () => import("./real-estate-form-dashboard/real-estate-form-dashboard.module.ngfactory").then((m) => m.RealEstateFormDashboardModuleNgFactory);
const routes = [
    {
        path: "login",
        component: LoginComponent,
    },
    {
        path: "dashboard",
        canActivate: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: "",
                component: DashboardComponent,
            },
        ],
    },
    {
        path: "funding-project",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: FundingProjectComponent,
            },
        ],
    },
    {
        path: "charging-project-setup",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: ChargingProjectSetupComponent,
            },
        ],
    },
    {
        path: "activity-selection",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: ActivitySelectionComponent,
            },
        ],
    },
    {
        path: "summary",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: SummaryComponent,
            },
        ],
    },
    {
        path: "project-setups",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: ProjectSetupsComponent,
            },
        ],
    },
    {
        path: "estimate",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: EstimateComponent,
            },
        ],
    },
    {
        path: "it-project-setup",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: ItProjectSetupComponent,
            },
        ],
    },
    {
        path: "rre-projects",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        loadChildren: ɵ0,
    },
    {
        path: "it-project-estimate",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: ItProjectEstimateComponent,
            },
        ],
    },
    {
        path: "it-project-review",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: ItProjectReviewComponent,
            },
        ],
    },
    {
        path: "it-project-approval",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: ItProjectApprovalComponent,
            },
        ],
    },
    {
        path: "form-dashboard",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        loadChildren: ɵ1,
    },
    {
        path: "real-estate-form-dashboard",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        loadChildren: ɵ2,
    },
    {
        path: "real-estate-project",
        canActivate: [AuthGuard],
        component: ProjectLayoutComponent,
        children: [
            {
                path: "",
                component: RealEstateProjectComponent,
            },
        ],
    },
    { path: "", redirectTo: "/login", pathMatch: "full" },
    { path: "**", redirectTo: "/login", pathMatch: "full" },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2 };
